const uspGlobal = () => {
  $(window).on('load resize', function () {
    if ($(window).width() <= 480) {
      $('.usp-global .container').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        settings: 'unslick',
      });
    } else if ($(window).width() <= 1180) {
      $('.usp-global .container').slick({
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        settings: 'unslick',
      });
    } else if ($(window).width() <= 1360) {
      $('.usp-global .container').slick({
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        settings: 'unslick',
      });
    }
  });
}; // Mobile/tab Only Slider

export default uspGlobal;
